// modules/calendar/services/ExternAppointmentScheduleService.ts
import { Container, IInit } from '../../../common/container/Container'
import { IStatusService } from '../../../common/status/StatusService'
import { Observable } from 'rxjs'
import { Query } from '../../../common/api/Query'
import { ItemList } from '../../../common/models/ItemList'
import { ExternAppointmentSchedule } from '../models/ExternAppointmentSchedule'
import { ExternAppointmentScheduleDTO, fromModel } from '../models/ExternAppointmentScheduleDTO'
import { IExternAppointmentScheduleApi } from '../api/ExternAppointmentScheduleApi'
import { STATUS_SERVICE_KEY } from '../../../container/app'

type Props = {
  apiKey: symbol
}

export interface IExternAppointmentScheduleService extends IInit {
  getFilteredList(
    q: Query<ExternAppointmentSchedule>
  ): Observable<ItemList<ExternAppointmentSchedule>>
  getById(id: string): Observable<ExternAppointmentSchedule | undefined>
  add(schedule: ExternAppointmentSchedule): Observable<ExternAppointmentSchedule | undefined>
  update(
    id: string,
    schedule: ExternAppointmentSchedule
  ): Observable<ExternAppointmentSchedule | undefined>
  delete(id: string): Observable<boolean>
  saveSchedule(
    schedule: ExternAppointmentSchedule
  ): Observable<ExternAppointmentSchedule | undefined>
  getProfessionalAvailability(
    userId: string,
    startDays?: number,
    days?: number
  ): Observable<ItemList<ExternAppointmentSchedule>>
}

export class ExternAppointmentScheduleService implements IExternAppointmentScheduleService {
  private readonly _apiKey: symbol
  private _container!: Container
  private _api!: IExternAppointmentScheduleApi
  private _statusService!: IStatusService

  constructor(p: Props) {
    this._apiKey = p.apiKey
  }

  init(c: Container) {
    this._container = c
    this._api = this._container.get<IExternAppointmentScheduleApi>(this._apiKey)
    this._statusService = this._container.get<IStatusService>(STATUS_SERVICE_KEY)
  }

  getFilteredList(
    q: Query<ExternAppointmentSchedule>
  ): Observable<ItemList<ExternAppointmentSchedule>> {
    return this._api.getFilteredList(q)
  }

  getById(id: string): Observable<ExternAppointmentSchedule | undefined> {
    return this._api.getById(id)
  }

  add(schedule: ExternAppointmentSchedule): Observable<ExternAppointmentSchedule | undefined> {
    const dto = fromModel(schedule)
    return this._api.add(dto)
  }

  update(
    id: string,
    schedule: ExternAppointmentSchedule
  ): Observable<ExternAppointmentSchedule | undefined> {
    const dto = fromModel(schedule)
    return this._api.update(id, dto)
  }

  delete(id: string): Observable<boolean> {
    return this._api.delete(id)
  }

  saveSchedule(
    schedule: ExternAppointmentSchedule
  ): Observable<ExternAppointmentSchedule | undefined> {
    if (schedule.id) {
      return this.update(schedule.id, schedule)
    } else {
      return this.add(schedule)
    }
  }

  getProfessionalAvailability(
    userId: string,
    startDays?: number,
    days?: number
  ): Observable<ItemList<ExternAppointmentSchedule>> {
    return this._api.getProfessionalAvailability(userId, startDays, days)
  }
}
